import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import React from "react";
import { dressPage1 } from "../../../Data/dress/page1";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteProduct, findProducts } from "../../../Redux/Customers/Product/Action";
import UpdateProductPopup from "../updateProduct/updateprouctFormPopup";
import api from "../../../config/api";

const ProductsTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customersProduct } = useSelector((store) => store);
  const [filterValue, setFilterValue] = useState({
    availability: "",
    category: "",
    sort: "",
  });

  // query 
  const searchParams = new URLSearchParams(location.search);
  const availability = searchParams.get("availability");
  const category = searchParams.get("category");
  const sort = searchParams.get("sort");
  const page = searchParams.get("page");


  const handlePaginationChange = (event, value) => {
    searchParams.set("page", value - 1);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  useEffect(() => {
    // setFilterValue({ availability, category, sort });c
    const data = {
      category: category || "",
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 100000,
      minDiscount: 0,
      sort: sort || "price_low",
      pageNumber: 1 || 10,
      pageSize: 8,
      stock: availability,
    };
    dispatch(findProducts(data));
  }, [availability, category, sort, page, customersProduct.deleteProduct]);

  const handleFilterChange = (e, sectionId) => {
    console.log(e.target.value, sectionId);
    setFilterValue((values) => ({ ...values, [sectionId]: e.target.value }));
    searchParams.set(sectionId, e.target.value);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  const handleLowStockChange = () => {
    setFilterValue(prevState => ({
      ...prevState,
      lowStock: !prevState.lowStock // Toggle the lowStock value
    }));
  };

  // Ensure filteredAndSortedProducts is always an array
  const originalProducts = customersProduct?.products?.content || [];
  const [filteredAndSortedProducts, setFilteredAndSortedProducts] = useState(originalProducts);

  useEffect(() => {
    let updatedProducts = [...originalProducts];

    if (filterValue.lowStock) {
      updatedProducts = updatedProducts.sort((a, b) => (a.quantity || 0) - (b.quantity || 0));
    }

    setFilteredAndSortedProducts(updatedProducts);
  }, [filterValue.lowStock, originalProducts]);


  const handleDeleteProduct = (productId) => {
    console.log("delete product ", productId)
    dispatch(deleteProduct(productId))
  }


  // State for managing popup form visibility and selected product for editing
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Function to open the update popup
  const handleEditProduct = (product) => {
    setSelectedProduct(product); // Set the product data to be edited
    setOpenPopup(true); // Open the update product popup
  };

  const [allcategory, setallcategory] = useState([])

  const getallCatergory = async () => {
  // const allcategory = await api.get("/api/products/category/3");

    // console.log("allcategory",allcategory.data)
    const response = await api.get("/api/products/category/3"); // Fixed: add `/` at start
    setallcategory(response.data || []);

  }

  useEffect(() => {
    getallCatergory()
  }, [])

  console.log("allcategory", allcategory)

  return (
    <Box width={"100%"}>
      <Card className="p-3">
        <CardHeader
          title="Sort"
          sx={{
            pt: 0,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <FormControl fullWidth>
                <InputLabel
                  sx={{
                    // Remove background color and set label to transparent
                    backgroundColor: 'transparent',
                    '&.Mui-focused': {
                      backgroundColor: 'transparent', // Ensure no background when focused
                    },
                    paddingLeft: '5px', // Optional: Adjust padding to align the label correctly
                    paddingRight: '5px',
                  }}
                  id="demo-simple-select-label">Category</InputLabel>
                <Autocomplete
                  freeSolo
                  disablePortal
                  id="category-select"
                  options={allcategory}
                  label="categ"
                  getOptionLabel={(option) => option.name}
                  value={null}
                  inputValue={filterValue.category || ''}
                  onInputChange={(event, newInputValue) => {
                    setFilterValue((prevState) => ({ ...prevState, category: newInputValue }));

                    // If input is cleared, reset the category to empty string or default behavior
                    if (!newInputValue) {
                      handleFilterChange({ target: { value: '' } }, 'category'); // Reset filter value when input is cleared
                    }
                  }}

                  onChange={(event, newValue) => {
                    const selectedCategory = newValue ? newValue.name : '';
                    handleFilterChange({ target: { value: selectedCategory } }, "category");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Category" />
                  )}
                  isOptionEqualToValue={(option, value) => option.name === value}

                  sx={{
                    '& .MuiAutocomplete-popover': {
                      borderRadius: '8px',
                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Add drop shadow
                    },
                    '& .MuiAutocomplete-listbox': {
                      borderRadius: '8px',
                      maxHeight: '450px',  // Max height to make it scrollable
                      overflowY: 'auto',
                    }, 
                   
                  }}
                    slotProps={{
    popper: {
      sx: {
        zIndex: 10,   // ✅ forces dropdown above others
      },
    },
  }}


                  clearOnEscape
                />

              </FormControl>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Availability
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterValue.availability}
                label="Availability"
                onChange={(e) => handleFilterChange(e, "availability")}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"in_stock"}>Instock</MenuItem>
                <MenuItem value={"out_of_stock"}>Out Of Stock</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Sort By Price
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filterValue.sort}
                label="Sort By Price"
                onChange={(e) => handleFilterChange(e, "sort")}
              >
                <MenuItem value={"price_high"}>Heigh - Low</MenuItem>
                <MenuItem value={"price_low"}>Low - Heigh</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filterValue.lowStock}
                  onChange={handleLowStockChange}
                  name="lowStock"
                  color="primary"
                />
              }
              label="low stock"
            />
          </Grid>


        </Grid>
      </Card>
      <Card className="mt-2">
        <CardHeader
          title="All Products"
          sx={{
            pt: 2,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        <TableContainer>
          <Table sx={{ minWidth: 800 }} aria-label="table in dashboard">
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell>Title</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Category</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Price</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Quantity</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAndSortedProducts?.map((item) => {
                const imageUrl = Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl;
                return (
                  <TableRow
                    hover
                    key={item.name}
                    sx={{ "&:last-of-type td, &:last-of-type th": { border: 0 } }}

                  >
                    <TableCell>
                      {" "}
                      <Avatar alt={item.titel} src={imageUrl} />{" "}
                    </TableCell>

                    <TableCell
                      sx={{ py: (theme) => `${theme.spacing(0.5)} !important` }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.875rem !important",
                          }}
                        >
                          {item.title}
                        </Typography>
                        <Typography variant="caption">{item.brand}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{item.category.name}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{item.discountedPrice}</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>{item.quantity}</TableCell>

                    <TableCell sx={{ textAlign: "center" }}>
                      <Button variant="text" onClick={() => handleDeleteProduct(item._id)}>Delete</Button>
                    </TableCell>

                    <TableCell sx={{ textAlign: "center" }}>
                      <Button variant="text" onClick={() => handleEditProduct(item)}>
                        Edit
                      </Button>
                    </TableCell>

                  </TableRow>
                )
              }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
  

        <div className="mx-auto px-4 py-5 flex justify-center shadow-lg rounded-md">
          <Pagination
            count={customersProduct.products?.totalPages}
            color="primary"
            className=""
            onChange={handlePaginationChange}
            value={page}
          />
        </div>
    
      <UpdateProductPopup
        open={openPopup}
        handleClose={() => setOpenPopup(false)}
        productId={selectedProduct?._id}
        product={selectedProduct}
      />

    </Box>
  );
};

export default ProductsTable;
